export const partneragentJson = {
    Partner_Agent_Id: '',
    Partner_Agent: '',
    Created_By: '',
    Created_On: '',
    Modified_By: '',
    Modified_On: '',
    Active: '',
    Country_Id: '0',
    PartnerAgent_Address: '',
    Affiliation: '0',
    Affiliation_Pathway: '0',
    Contact_Person: '',
    Contact_Number: '0',
    Contact_Email: '',
    Commision_Percentage_PG: '0',
    Commision_Percentage_UG: '0',
    Commision_Percentage_Other: '0',
    Commision_Including_GST: '0',
    Split_Percentage: '0',
    Commission_Duration: '0',
    Lumpsum_Commision: '',
    Attachment_Name: ''
}